import React from 'react';
import { Button, Modal as ModalStrap, Container, ModalBody, ModalFooter } from 'reactstrap';

const Modal = ({ children, open, actions, className, onClose,title ,heightOffset}) => {
    return (
        <React.Fragment>
            <ModalStrap toggle={onClose} isOpen={open?true:false} className={className} size="lg" style={{paddingTop:heightOffset}}>
                <Container style={{backgroundColor:'lightblue'}}>{title}</Container>
                <ModalBody>
                    {children}
                </ModalBody>
                <ModalFooter>
                    {actions}
                    <Button color="secondary" onClick={onClose}>Close Window</Button>
                </ModalFooter>
            </ModalStrap>

        </React.Fragment>
    );

};
export default Modal; 

